import { createSelector } from '@reduxjs/toolkit';
import { generateDemoMemories } from '@timelyapp/integration-cloud-sdk/memory-demo-data';
import { getTicViewDemoMode } from './tic.demo.selectors';
import { getTicMemoryDate } from './tic.legacy-memories.selectors';

export const getDemoMemoriesData = createSelector(
  [getTicMemoryDate, getTicViewDemoMode],
  (date, demoModeSettings) => {
    if (!demoModeSettings.enabled) {
      return {
        entries: [],
        blocks: [],
      };
    }
    return generateDemoMemories(demoModeSettings, {
      date,
    });
  }
);
